import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/AmusementService`;

const AmusementService = {
  getAll: (params) => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params });
  },
  getAllAmusementServices: () => {
    const url = `${baseServiceUrl}/getAllAmusementServices`;
    return ServiceApi.get(url);
  },
  getAllAmusementGroups: (params) => {
    const url = `${baseServiceUrl}/getAllAmusementGroups`;
    return ServiceApi.get(url,{ params });
  },
  getAllServicesByGroupId: (params) => {
    const url = `${baseServiceUrl}/getAllServicesByGroupId`;
    return ServiceApi.get(url, { params });
  },
  getAmusementReserveItem: (params) => {
    const url = `${baseServiceUrl}/getAmusementReserveItem`;
    return ServiceApi.get(url, { params });
  },
  getAmusementReserveItemGroup: (params) => {
    const url = `${baseServiceUrl}/getAmusementReserveItemGroup`;
    return ServiceApi.get(url, { params });
  },
  getReserveDetails: (params) => {
    const url = `${baseServiceUrl}/getReserveDetails`;
    return ServiceApi.get(url, { params });
    },


};

export default AmusementService;


